/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LineGraphicsComponent } from './line-graphics.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { FormsModule } from '@angular/forms';
import { SysqueSelectBoxModule } from '../../../../../../../shared/ui/src/lib/components/sysque-select-box';
import { AngularDraggableModule } from 'angular2-draggable';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [{ path: 'dialog/line-graphics-dialog', component: LineGraphicsComponent }];

@NgModule({
  declarations: [LineGraphicsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ColorPickerModule,
    SysqueSelectBoxModule,
    AngularDraggableModule,
    RouterModule.forChild(routes)
  ],
  exports: [LineGraphicsComponent]
})
export class LineGraphicsModule { }
